CartEngravingHandler.prototype.checkCartItems = function() {
  var self = this;
  this.getCart().then(function(cart) {
    self.processCartItems(cart.items);
  });
};function CartEngravingHandler() {
  this.engravingVariantId = '45356441567403';
  this.debounceTimer = null;
  this.debounceDelay = 800;
  this.isProcessing = false;
  this.init();
}

CartEngravingHandler.prototype.init = function() {
  this.observeCartChanges();
  this.observeAddToCartGlobally();
};

CartEngravingHandler.prototype.observeCartChanges = function() {
  var self = this;
  
  // Listen for quantity input changes
  document.addEventListener('change', function(event) {
    if (event.target.name && event.target.name.includes('updates[')) {
      console.log('Quantity change detected');
      self.debouncedCheckCartItems();
    }
  });
  
  // Listen for remove button clicks
  document.addEventListener('click', function(event) {
    var target = event.target;
    var removeButton = target.closest('.cart-items__remove, [data-cart-remove], .remove-item');
    
    if (removeButton) {
      console.log('Remove button clicked');
      self.debouncedCheckCartItems();
    }
  });
  
  // Listen for quantity selector button clicks
  document.addEventListener('click', function(event) {
    var target = event.target;
    var quantityButton = target.closest('.quantity-selector button, .qty-btn, [data-quantity-change]');
    
    if (quantityButton) {
      console.log('Quantity button clicked');
      self.debouncedCheckCartItems();
    }
  });
};

CartEngravingHandler.prototype.observeAddToCartGlobally = function() {
  var self = this;
  
  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (form && form.action && form.action.includes('/cart/add')) {
      self.debouncedCheckCartItems();
    }
  });
  
  var originalFetch = window.fetch;
  window.fetch = function(url, options) {
    if (url && (url.includes('/cart/add') || url.includes('/cart/change'))) {
      self.debouncedCheckCartItems();
    }
    return originalFetch.apply(this, arguments);
  };
  
  document.addEventListener('cart:updated', function() {
    self.debouncedCheckCartItems();
  });
  
  document.addEventListener('cart:refresh', function() {
    self.debouncedCheckCartItems();
  });
  
  document.addEventListener('cart:changed', function() {
    self.debouncedCheckCartItems();
  });
  
  document.addEventListener('click', function(event) {
    var target = event.target;
    var button = target.closest('[name="add"], .btn-cart, .add-to-cart, .product-form__cart-submit, [data-add-to-cart]');
    
    if (button) {
      self.debouncedCheckCartItems();
    }
  });
};

CartEngravingHandler.prototype.debouncedCheckCartItems = function() {
  var self = this;
  
  if (this.isProcessing) {
    console.log('Already processing, ignoring action');
    return;
  }
  
  console.log('Starting cart check process');
  
  if (this.debounceTimer) {
    clearTimeout(this.debounceTimer);
  }
  
  this.disableCartForm();
  
  this.debounceTimer = setTimeout(function() {
    console.log('Debounce completed, checking cart');
    self.checkCartItems();
  }, this.debounceDelay);
};

CartEngravingHandler.prototype.disableCartForm = function() {
  this.isProcessing = true;
  var cartForm = document.getElementById('cart-form');
  if (cartForm) {
    console.log('Disabling cart form');
    cartForm.style.opacity = '0.5';
    cartForm.style.pointerEvents = 'none';
    cartForm.style.transition = 'opacity 0.3s ease';
  } else {
    console.log('Cart form not found');
  }
};

CartEngravingHandler.prototype.waitForCartUpdate = function() {
  var self = this;
  
  function attemptCartSync(attempt) {
    var maxAttempts = 3;
    
    self.getCart().then(function(firstCart) {
      setTimeout(function() {
        self.getCart().then(function(secondCart) {
          if (self.cartsAreEqual(firstCart, secondCart)) {
            self.processCartItems(secondCart.items);
          } else {
            if (attempt < maxAttempts) {
              setTimeout(function() {
                attemptCartSync(attempt + 1);
              }, 500);
            } else {
              self.processCartItems(secondCart.items);
            }
          }
        }).catch(function() {
          if (attempt < maxAttempts) {
            setTimeout(function() {
              attemptCartSync(attempt + 1);
            }, 500);
          }
        });
      }, 300);
    }).catch(function() {
      if (attempt < maxAttempts) {
        setTimeout(function() {
          attemptCartSync(attempt + 1);
        }, 500);
      }
    });
  }
  
  attemptCartSync(1);
};

CartEngravingHandler.prototype.cartsAreEqual = function(cart1, cart2) {
  if (!cart1 || !cart2 || !cart1.items || !cart2.items) {
    return false;
  }
  
  if (cart1.items.length !== cart2.items.length) {
    return false;
  }
  
  for (var i = 0; i < cart1.items.length; i++) {
    var item1 = cart1.items[i];
    var item2 = cart2.items[i];
    
    if (item1.id !== item2.id || item1.quantity !== item2.quantity) {
      return false;
    }
  }
  
  return true;
};

CartEngravingHandler.prototype.processCartItems = function(items) {
  console.log('Processing cart items, total items:', items.length);
  
  var totalEngravingNeeded = 0;
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    
    if (item.properties) {
      var engravingProperty = item.properties['Back side Engraving (+₹69)'];
      
      if (engravingProperty && engravingProperty !== 'no') {
        console.log('Found engraving property:', engravingProperty, 'quantity:', item.quantity);
        totalEngravingNeeded += item.quantity;
      }
    }
  }
  
  var currentEngravingQuantity = 0;
  var engravingItems = [];
  
  for (var j = 0; j < items.length; j++) {
    var cartItem = items[j];
    if (cartItem.id.toString() === this.engravingVariantId) {
      console.log('Found existing engraving item, quantity:', cartItem.quantity);
      currentEngravingQuantity += cartItem.quantity;
      engravingItems.push(cartItem);
    }
  }
  
  console.log('Total engraving needed:', totalEngravingNeeded);
  console.log('Current engraving quantity:', currentEngravingQuantity);
  
  if (totalEngravingNeeded !== currentEngravingQuantity) {
    if (totalEngravingNeeded === 0) {
      console.log('Removing all engraving');
      this.removeAllEngraving(engravingItems);
    } else if (currentEngravingQuantity === 0) {
      console.log('Adding engraving product');
      this.addEngravingProduct(totalEngravingNeeded);
    } else {
      console.log('Updating engraving quantity');
      this.updateEngravingToExactQuantity(totalEngravingNeeded, engravingItems);
    }
  } else {
    console.log('Sync complete - no changes needed');
    this.isProcessing = false;
  }
};

CartEngravingHandler.prototype.addEngravingProduct = function(quantity) {
  console.log('Adding engraving product with quantity:', quantity);
  
  var formData = {
    'items': [{
      'id': this.engravingVariantId,
      'quantity': quantity,
      'properties': {
        '_engraving_addon': 'true',
        '_readonly': 'true'
      }
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData)
  }).then(function(response) {
    console.log('Add to cart response status:', response.status);
    return response.json().then(function(data) {
      console.log('Add to cart response data:', data);
      if (response.ok) {
        console.log('Reloading page in 800ms');
        setTimeout(function() {
          window.location.reload();
        }, 800);
      }
    });
  }).catch(function(error) {
    console.error('Error adding engraving:', error);
  });
};

CartEngravingHandler.prototype.updateEngravingToExactQuantity = function(targetQuantity, engravingItems) {
  if (engravingItems.length > 0) {
    this.updateCartItemQuantity(engravingItems[0].key, targetQuantity);
    
    for (var i = 1; i < engravingItems.length; i++) {
      this.updateCartItemQuantity(engravingItems[i].key, 0);
    }
    
    setTimeout(function() {
      window.location.reload();
    }, 800);
  }
};

CartEngravingHandler.prototype.removeAllEngraving = function(engravingItems) {
  for (var i = 0; i < engravingItems.length; i++) {
    this.updateCartItemQuantity(engravingItems[i].key, 0);
  }
  
  setTimeout(function() {
    window.location.reload();
  }, 800);
};

CartEngravingHandler.prototype.updateCartItemQuantity = function(key, quantity) {
  var updateData = {
    'id': key,
    'quantity': quantity
  };
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(updateData)
  });
};

CartEngravingHandler.prototype.getCart = function() {
  return fetch('/cart.js')
    .then(function(response) {
      return response.json();
    })
    .catch(function() {
      return { items: [] };
    });
};

document.addEventListener('DOMContentLoaded', function() {
  new CartEngravingHandler();
});